const varParser = (msg, vars) => {
  return msg
    .split("{{")
    .map((item) => {
      const secondSplit = item.split("}}");
      if (secondSplit.length === 1) { return item; }
      return secondSplit
        .map((phrase, i) => {
          if (i) { return phrase; }
          return vars[0][phrase];
        })
        .join("");
    })
    .join("");
};
export default varParser;
